import type { YearSummary } from '../../../entities/summary/index.js';
import { formatMonthName } from '../../../features/payment-view/index.js';

type SummaryPeriod = Pick<YearSummary, 'year' | 'month'>;

export const spendingLabelOf = (summary: SummaryPeriod): string =>
  summary.month === null
    ? `Витрати за ${String(summary.year)} рік`
    : `Витрати за ${formatMonthName(summary.month)} ${String(summary.year)}`;
